<template>
  <section class="relative">
    <slot :is-valid="isValid" :error-messages="errorMessages" />
    <SFFadeInFromBottomTransition>
      <ul v-if="!isValid">
        <li
          v-for="(message, index) in errorMessages"
          :key="index"
          class="ml-1 mt-1 text-start"
        >
          <p
            aria-live="assertive"
            data-testid="validation-error-text"
            class="text-md font-normal text-red-500"
          >
            {{ message }}
          </p>
        </li>
      </ul>
    </SFFadeInFromBottomTransition>
  </section>
</template>

<script setup lang="ts">
import type { ErrorObject } from '@vuelidate/core'
import { computed } from 'vue'
import { SFFadeInFromBottomTransition } from '#storefront-ui/components'

type Errors = ErrorObject[] | string[]

const { errors = [] } = defineProps<{ errors?: Errors }>()

const isValid = computed(() => !errors.length)

const errorMessages = computed(() => {
  return errors.map((it) => (typeof it === 'string' ? it : it.$message))
})
</script>
